var _style, _path, _path2, _path3, _path4, _defs, _polygon, _defs2, _polygon2, _defs3, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNodejs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#689F63;}\r\n\t.st1{fill:#404137;}\r\n\t.st2{clip-path:url(#XMLID_39_);fill:url(#SVGID_1_);}\r\n\t.st3{clip-path:url(#XMLID_40_);fill:url(#SVGID_2_);}\r\n\t.st4{clip-path:url(#XMLID_41_);fill:url(#SVGID_3_);}\r\n")), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2_",
    className: "st0",
    d: "M247.9,361.8c-1.2,0-2.4-0.3-3.5-0.9l-11-6.5c-1.6-0.9-0.8-1.2-0.3-1.4c2.2-0.8,2.6-0.9,5-2.3 c0.2-0.1,0.6-0.1,0.8,0.1l8.5,5c0.3,0.2,0.7,0.2,1,0l33-19c0.3-0.2,0.5-0.5,0.5-0.9v-38c0-0.4-0.2-0.7-0.5-0.9l-32.9-19 c-0.3-0.2-0.7-0.2-1,0l-32.9,19c-0.3,0.2-0.5,0.5-0.5,0.9v38c0,0.4,0.2,0.7,0.5,0.9l9,5.2c4.9,2.5,7.9-0.4,7.9-3.3V301 c0-0.5,0.4-0.9,1-0.9h4.2c0.5,0,0.9,0.4,0.9,0.9v37.6c0,6.5-3.6,10.3-9.8,10.3c-1.9,0-3.4,0-7.6-2.1l-8.6-5c-2.1-1.2-3.5-3.5-3.5-6 v-38c0-2.5,1.3-4.8,3.5-6l33-19c2.1-1.2,4.9-1.2,6.9,0l33,19c2.1,1.2,3.5,3.5,3.5,6v38c0,2.5-1.3,4.8-3.5,6l-33,19 C250.3,361.4,249.1,361.8,247.9,361.8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3_",
    className: "st0",
    d: "M258.1,335.6c-14.4,0-17.4-6.6-17.4-12.2c0-0.5,0.4-0.9,1-0.9h4.3c0.5,0,0.9,0.3,0.9,0.8 c0.6,4.3,2.6,6.5,11.3,6.5c6.9,0,9.9-1.6,9.9-5.3c0-2.1-0.8-3.7-11.6-4.8c-9-0.9-14.6-2.9-14.6-10.1c0-6.7,5.6-10.6,15-10.6 c10.6,0,15.8,3.7,16.4,11.5c0,0.3-0.1,0.5-0.3,0.7c-0.2,0.2-0.4,0.3-0.7,0.3h-4.3c-0.4,0-0.8-0.3-0.9-0.7c-1-4.6-3.5-6-10.3-6 c-7.6,0-8.5,2.6-8.5,4.6c0,2.4,1,3.1,11.3,4.5c10.1,1.3,14.9,3.2,14.9,10.4C274.5,331.5,268.5,335.6,258.1,335.6 M298.2,295.3h1.1 c0.9,0,1.1-0.6,1.1-1c0-1-0.7-1-1-1h-1.1L298.2,295.3z M296.8,292.1h2.5c0.8,0,2.5,0,2.5,1.9c0,1.3-0.8,1.6-1.3,1.7 c1,0.1,1,0.7,1.2,1.6c0.1,0.6,0.2,1.6,0.4,1.9h-1.5c0-0.3-0.3-2.1-0.3-2.2c-0.1-0.4-0.2-0.6-0.7-0.6h-1.2v2.9h-1.4V292.1z  M293.9,295.7c0,3,2.4,5.3,5.3,5.3c3,0,5.3-2.4,5.3-5.3c0-3-2.4-5.3-5.3-5.3C296.3,290.4,293.9,292.7,293.9,295.7 M305.6,295.7 c0,3.5-2.9,6.4-6.4,6.4c-3.5,0-6.4-2.8-6.4-6.4c0-3.6,3-6.4,6.4-6.4C302.6,289.4,305.6,292.1,305.6,295.7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9_",
    className: "st1",
    d: "M145.8,212.9c0-1.5-0.8-2.9-2.1-3.7l-34.9-20.1c-0.6-0.3-1.3-0.5-1.9-0.6h-0.4 c-0.7,0-1.3,0.2-1.9,0.6l-34.9,20.1c-1.3,0.8-2.1,2.2-2.1,3.7l0.1,54.2c0,0.8,0.4,1.5,1,1.8c0.6,0.4,1.5,0.4,2.1,0L91.5,257 c1.3-0.8,2.1-2.2,2.1-3.7v-25.3c0-1.5,0.8-2.9,2.1-3.7l8.8-5.1c0.7-0.4,1.4-0.6,2.1-0.6c0.7,0,1.5,0.2,2.1,0.6l8.8,5.1 c1.3,0.8,2.1,2.1,2.1,3.7v25.3c0,1.5,0.8,2.9,2.1,3.7l20.8,11.9c0.7,0.4,1.5,0.4,2.1,0c0.6-0.4,1-1.1,1-1.8L145.8,212.9z  M310.7,241.1c0,0.4-0.2,0.7-0.5,0.9l-12,6.9c-0.3,0.2-0.7,0.2-1.1,0l-12-6.9c-0.3-0.2-0.5-0.5-0.5-0.9v-13.9 c0-0.4,0.2-0.7,0.5-0.9l12-6.9c0.3-0.2,0.7-0.2,1.1,0l12,6.9c0.3,0.2,0.5,0.5,0.5,0.9L310.7,241.1z M314,138.5 c-0.7-0.4-1.5-0.4-2.1,0c-0.6,0.4-1,1.1-1,1.8V194c0,0.5-0.3,1-0.7,1.3c-0.5,0.3-1,0.3-1.5,0l-8.8-5c-1.3-0.8-2.9-0.8-4.2,0 l-35,20.2c-1.3,0.8-2.1,2.1-2.1,3.6v40.4c0,1.5,0.8,2.9,2.1,3.7l35,20.2c1.3,0.8,2.9,0.8,4.2,0l35-20.2c1.3-0.8,2.1-2.1,2.1-3.7 V153.8c0-1.5-0.8-2.9-2.2-3.7L314,138.5z M430.4,226.9c1.3-0.8,2.1-2.1,2.1-3.6v-9.8c0-1.5-0.8-2.9-2.1-3.7l-34.7-20.2 c-1.3-0.8-2.9-0.8-4.2,0l-35,20.2c-1.3,0.8-2.1,2.1-2.1,3.7v40.3c0,1.5,0.8,2.9,2.1,3.7l34.7,19.8c1.3,0.7,2.8,0.7,4.1,0l21-11.7 c0.7-0.4,1.1-1.1,1.1-1.8c0-0.8-0.4-1.5-1.1-1.8l-35.2-20.2c-0.7-0.4-1.1-1.1-1.1-1.8v-12.7c0-0.8,0.4-1.5,1.1-1.8l10.9-6.3 c0.7-0.4,1.5-0.4,2.1,0l10.9,6.3c0.7,0.4,1.1,1.1,1.1,1.8v10c0,0.8,0.4,1.5,1.1,1.8c0.7,0.4,1.5,0.4,2.1,0L430.4,226.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_14_",
    className: "st0",
    d: "M393,225c0.2-0.1,0.6-0.1,0.8,0l6.7,3.9c0.3,0.1,0.4,0.4,0.4,0.7v7.7c0,0.3-0.2,0.6-0.4,0.7 l-6.7,3.9c-0.3,0.1-0.6,0.1-0.8,0l-6.7-3.9c-0.3-0.1-0.4-0.4-0.4-0.7v-7.7c0-0.3,0.1-0.6,0.4-0.7L393,225z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_15_"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_16_",
    d: "M200.1,189.9l-34.8,20.1c-1.3,0.8-2.1,2.1-2.1,3.6v40.2c0,1.5,0.8,2.9,2.1,3.6l34.8,20.1 c1.3,0.7,2.9,0.7,4.2,0l34.8-20.1c1.3-0.8,2.1-2.1,2.1-3.6v-40.2c0-1.5-0.8-2.9-2.1-3.6l-34.8-20.1c-0.7-0.4-1.4-0.6-2.1-0.6 S200.8,189.5,200.1,189.9"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_39_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_16_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.3773,
    y1: -0.04703351,
    x2: 0.9962,
    y2: -0.04703351,
    gradientTransform: "matrix(-81.162 165.5699 -165.5699 -81.162 250.1612 116.2246)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3E863D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#3E863D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#55934F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#5AAD45"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5AAD45"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "276.3,206.5 178.3,158.5 128.1,261 226.1,309  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_17_"
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_18_",
    d: "M164.1,256.3c0.3,0.4,0.7,0.8,1.2,1.1l29.8,17.2l5,2.9c0.7,0.4,1.6,0.6,2.4,0.5c0.3,0,0.6-0.1,0.8-0.2 l36.7-67.1c-0.3-0.3-0.6-0.6-1-0.8l-22.8-13.1l-12-6.9c-0.3-0.2-0.7-0.3-1.1-0.4L164.1,256.3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_40_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_18_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.05026797,
    y1: 0.1331,
    x2: 0.6691,
    y2: 0.1331,
    gradientTransform: "matrix(147.809 -109.2133 109.2133 147.809 134.3817 253.3567)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3E863D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    style: {
      stopColor: "#3E863D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    style: {
      stopColor: "#619857"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#76AC64"
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "121.8,220.7 190.9,314.3 282.4,246.8 213.2,153.1  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_19_"
  }, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_20_",
    d: "M201.8,189.3c-0.6,0.1-1.2,0.2-1.7,0.5l-34.7,20l37.4,68.1c0.5-0.1,1-0.2,1.5-0.5l34.8-20.1 c1.1-0.6,1.8-1.7,2-2.9L203,189.4c-0.3-0.1-0.6-0.1-0.8-0.1C202,189.3,201.9,189.3,201.8,189.3"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_41_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_20_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.1301,
    y1: 0.2836,
    x2: 0.7489,
    y2: 0.2836,
    gradientTransform: "matrix(122.2438 0 0 122.2438 149.5464 198.9629)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6BBF47"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#6BBF47"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "#79B461"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    style: {
      stopColor: "#75AC64"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#659E5A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    style: {
      stopColor: "#3E863D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3E863D"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 165.5,
    y: 189.3,
    className: "st4",
    width: 75.6,
    height: 88.6
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodejs);
export default __webpack_public_path__ + "static/media/nodejs.f163cddfbfe49648deb1ce8917207b77.svg";
export { ForwardRef as ReactComponent };